export enum RefStatutJureCode {
    INSCRIT = 'INSCRIT',
    EXCUSE = 'EXCUSE',
    PRESENT = 'PRESENT',
    ABSENT = 'ABSENT',
    DESINSCRIT = 'DESINSCRIT',
    CONVOQUE = 'CONVOQUE',
    A_CONVOQUER = 'A_CONVOQUER'
}
